module.exports = __webpack_public_path__ + "static/img/1666_phase_function_Paper_PointsHejduk_Prediction.f374136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1666_phase_function_Paper_PointsHejduk_Prediction.png
// module id = utIt
// module chunks = 0